/*eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { get_api } from "api";

import { toast } from "react-toastify";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const useMessagesHook = () => {
    const location = useLocation();
    const [chatList, setChatList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [receiverObj, setReceiverObj] = useState({});
    const [receiverLoader, setReceiverLoader] = useState(false);
    const [open, setOpen] = useState(false);
    const [allMessages, setAllMessages] = useState([]);
    
    useEffect(() => {
        const getAllMessages = async () => {
            // Load list of all chats
            setIsLoading(true);
            try {
              const { data } = await get_api(`chat`);
              setChatList(data.chatRooms);
            } catch (err) {
              toast.error(err.message);
            } finally {
              setIsLoading(false);
            }
        };
        getAllMessages();
    }, []); //TODO: implement pagination as dependency
    
    useEffect(() => {
        if (location?.state?.chatId) {
            loadChatMessages( location?.state?.chatId );
        }
    }, [location?.state?.chatId]);

    const formatMessageTime = (timestamp) => {
        //const milliseconds = (timestamp.seconds || 0) * 1000 + (timestamp.nanoseconds || 0) / 1000000;
        const date = dayjs(timestamp);

        // Check if the date is valid
        if (!date.isValid()) {
            return "Invalid Time";
        }

        // Format the date to show only the time
        return date.tz("Australia/Sydney").format(" h:mm A, ddd M MMM YYYY"); // Adjust timezone if needed
    };
    
    const loadChatMessages = async ( chat_id, chat_obj ) => {
        setReceiverLoader(true);
        
        // TODO: load message view screen
        // then call 'setAllMessages()'
        try {
          const { data } = await get_api(`chat/${chat_id}`);
          setAllMessages(data.chatRoomData);
          setReceiverObj(chat_obj);
        } catch (err) {
          toast.error(err.message);
        } finally {
          setReceiverLoader(false);
        }
    }

    return {
        isLoading,
        chatList,
        open,
        setOpen,
        formatMessageTime,
        receiverObj,
        receiverLoader,
        loadChatMessages,
        allMessages,
    };
};

export default useMessagesHook;
